import { MutationTree } from 'vuex';
import { IFundHistoryState } from './types';

const mutations: MutationTree<IFundHistoryState> = {
  reset(state) {
    state.items = [];
  },

  items(state, items) {
    state.items = items;
  },

  setBusinessCode(state, businessCode) {
    state.businessCode = businessCode;
  },

  setSelectedResultIndex(state, newIndex) {
    state.selectedResultIndex = newIndex;
  },

  setCacheSuffix(state, cacheSuffix) {
    state.cacheSuffix = cacheSuffix;
  },
};

export default mutations;
